"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SliderPart = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const _part_includes_1 = require("../_part_includes");
//@ts-ignore                
let rwsTemplate = T.html `<div class="form-group slider-group">
    ${(0, fast_element_1.when)(x => x.label, T.html `<label htmlFor="${x => x.name}" style="--labelBotMargin: ${x => x.labelBotMargin}px;" class="slider-label">${x => x.label.t()}</label>`)}
    
    <div class="range-wrap${x => x.showValue === 'true' ? '' : ' without-value'}">
        ${(0, fast_element_1.when)(x => x.showValue === 'true', T.html `
            <output class="range-bubble" style="left: calc(${x => x.getValuePosition()}% + ${x => 8 - (x.getValuePosition() * 0.16)}px);">${x => x.displayValue}</output>
        `)}
        <input 
            ${(0, fast_element_1.ref)('sliderElement')}
            type="range"
            @input="${(x, c) => x.handleSliderInput(c.event)}"
            @change="${(x, c) => x.handleChange(c.event)}"
            name="${x => x.name}"
            class="slider-input"
            style="--range-progress: ${x => x.getValuePosition()}%"
            :value="${x => x.value}"
            min="${x => x.min}"
            max="${x => x.max}"
            step="${x => x.step}"
            ?required="${x => x.isRequired}"
        />
    </div>
    
    <div class="range-scale slider-labels">
        <span class="min-label">${x => x.minLabel ? x.minLabel : x.min + (x.unit ? ' ' + x.unit : '')}</span>
        <span class="max-label">${x => x.maxLabel ? x.maxLabel : x.max + (x.unit ? ' ' + x.unit : '')}</span>
    </div>
</div>`;
require("./styles/layout.scss");
const styles = T.css `:host-context(.force-placeholder) input::placeholder,
select::placeholder,
textarea::placeholder {
  opacity: 1 !important;
}

.form-group.is-invalid label {
  color: var(--error_color) !important;
}
.form-group.is-invalid .form-control {
  border-color: var(--error_color) !important;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075) !important;
  color: var(--error_color) !important;
}

:host(.no-margin) .form-group {
  margin: 0 !important;
}

:host(.mini) .form-control {
  padding: 0.2rem 0.4rem;
  line-height: 0.8;
  font-size: 0.6rem;
}

:host(.rounded) .form-control {
  border-radius: 0.375rem;
}

.slider-group {
  margin-bottom: 1rem;
}

.slider-label {
  display: block;
  margin-bottom: var(--labelBotMargin);
  font-weight: 500;
  color: var(--muted, var(--label-color, #8a8f9c));
  font-size: 0.92rem;
}

.range-wrap {
  position: relative;
  padding-top: 30px;
}
.range-wrap.without-value {
  padding-top: 0;
}

.slider-input {
  width: 100%;
  height: 16px;
  margin: 0;
  -webkit-appearance: none;
  appearance: none;
  background: transparent;
  outline: none;
  cursor: pointer;
}
.slider-input::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 16px;
  height: 16px;
  margin-top: -5px;
  border-radius: 50%;
  background: var(--primary-color);
  border: 2px solid #fff;
  box-shadow: 0 1px 4px rgba(31, 44, 85, 0.3);
  transition: box-shadow 0.15s ease, background-color 0.15s ease;
}
.slider-input::-moz-range-thumb {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: var(--primary-color);
  border: 2px solid #fff;
  box-shadow: 0 1px 4px rgba(31, 44, 85, 0.3);
  transition: box-shadow 0.15s ease, background-color 0.15s ease;
}
.slider-input::-webkit-slider-runnable-track {
  width: 100%;
  height: 6px;
  cursor: pointer;
  background: linear-gradient(to right, var(--primary-color) var(--range-progress), var(#e4e7ec) var(--range-progress));
  border-radius: 999px;
  border: none;
}
.slider-input::-moz-range-track {
  width: 100%;
  height: 6px;
  cursor: pointer;
  background: var(#e4e7ec);
  border-radius: 999px;
  border: none;
}
.slider-input::-moz-range-progress {
  height: 6px;
  background: var(--primary-color);
  border-radius: 999px;
}
.slider-input:focus {
  outline: none;
}
.slider-input:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 3px rgba(23, 180, 166, 0.2), 0 1px 4px rgba(31, 44, 85, 0.3);
}
.slider-input:focus::-moz-range-thumb {
  box-shadow: 0 0 0 3px rgba(23, 180, 166, 0.2), 0 1px 4px rgba(31, 44, 85, 0.3);
}
.slider-input:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.range-bubble {
  position: absolute;
  top: 0;
  transform: translateX(-50%);
  padding: 2px 8px;
  border-radius: 6px;
  background: var(#2f2f3a);
  color: #fff;
  font-size: 0.75rem;
  font-weight: 700;
  white-space: nowrap;
  pointer-events: none;
}
.range-bubble::after {
  content: "";
  position: absolute;
  left: 50%;
  bottom: -4px;
  border: 4px solid transparent;
  border-bottom: 0;
  border-top-color: var(#2f2f3a);
  transform: translateX(-50%);
}

.slider-labels {
  display: flex;
  justify-content: space-between;
  margin-top: 4px;
  color: var(#8a8f9c);
  font-size: 0.72rem;
}

.min-label,
.max-label {
  min-width: 0;
}`;
const shadowOptions = { "mode": "open" };
let SliderPart = class SliderPart extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.labelBotMargin = 8;
        this.value = 0;
        this.min = 0;
        this.max = 100;
        this.step = 1;
        this.ignored = 'false';
        this.dontEmit = false;
        this.showValue = 'true';
        this.unit = '';
        this.displayValue = '0';
        this.handleChange = _part_includes_1.handlePartChange.bind(this);
    }
    requiredChanged(oldValue, newValue) {
        this.required = newValue;
        this.isRequired = this.required === 'true';
    }
    valueChanged(oldValue, newValue) {
        this.displayValue = newValue + (this.unit ? ' ' + this.unit : '');
        // Force update the slider element value
        if (this.sliderElement) {
            this.sliderElement.value = newValue;
        }
    }
    getElement() {
        return this.sliderElement;
    }
    connectedCallback() {
        super.connectedCallback();
        this.displayValue = (this.value || '0') + (this.unit ? ' ' + this.unit : '');
        // Ensure the slider element gets the correct initial value
        setTimeout(() => {
            if (this.sliderElement && this.value !== undefined) {
                this.sliderElement.value = this.value.toString();
            }
        }, 0);
    }
    reset() {
        this.value = this.min || 0;
        this.displayValue = this.value + (this.unit ? ' ' + this.unit : '');
    }
    handleSliderInput(event) {
        const target = event.target;
        this.value = Number(target.value);
        this.displayValue = this.value + (this.unit ? ' ' + this.unit : '');
        this.handleChange(event);
    }
    getValuePosition() {
        var _a;
        const min = Number(this.min);
        const max = Number(this.max);
        const value = Number((_a = this.value) !== null && _a !== void 0 ? _a : min);
        if (!Number.isFinite(min) || !Number.isFinite(max) || max <= min) {
            return 0;
        }
        return Math.min(100, Math.max(0, ((value - min) / (max - min)) * 100));
    }
};
exports.SliderPart = SliderPart;
SliderPart.PART_TYPE = 'slider';
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], SliderPart.prototype, "label", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], SliderPart.prototype, "minLabel", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], SliderPart.prototype, "maxLabel", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], SliderPart.prototype, "name", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", Number)
], SliderPart.prototype, "labelBotMargin", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], SliderPart.prototype, "value", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], SliderPart.prototype, "type", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", Number)
], SliderPart.prototype, "min", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", Number)
], SliderPart.prototype, "max", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", Number)
], SliderPart.prototype, "step", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], SliderPart.prototype, "required", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], SliderPart.prototype, "placeholder", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], SliderPart.prototype, "ignored", void 0);
__decorate([
    (0, client_1.attr)({ mode: 'boolean' }),
    __metadata("design:type", Boolean)
], SliderPart.prototype, "dontEmit", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], SliderPart.prototype, "showValue", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], SliderPart.prototype, "unit", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], SliderPart.prototype, "isRequired", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], SliderPart.prototype, "displayValue", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Function)
], SliderPart.prototype, "onChange", void 0);
exports.SliderPart = SliderPart = __decorate([
    (0, client_1.RWSView)('part-slider', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], SliderPart);
SliderPart.defineComponent();
